import { format } from "date-fns";
import { MatchTimeContainer } from "./styles";

interface Props {
  timeMs: number;
  isDelayed: boolean;
}

export const MatchTime = ({ timeMs, isDelayed }: Props) => {
  const matchDate = new Date(timeMs);
  const startDay = format(matchDate, "dd/MM");
  const startTime = format(matchDate, "HH:mm");

  return (
    <MatchTimeContainer isDelayed={isDelayed}>
      <span>{startDay}</span>
      <span>{startTime}</span>
    </MatchTimeContainer>
  );
};
